import { Card } from "@/components/ui/card";

/** Small clickable KPI card. onClick → drill-down to the Leads list. */
export function StatCard({ label, value, sub, icon: Icon, accent = "text-indigo-600", onClick, testid }) {
  return (
    <Card
      className={`p-3 ${onClick ? "cursor-pointer hover:border-indigo-300 hover:shadow-sm transition-colors" : ""}`}
      onClick={onClick}
      data-testid={testid}
      title={onClick ? "Click to view these leads" : undefined}
    >
      <div className="flex items-center justify-between mb-1">
        <span className="text-[10px] uppercase tracking-wider text-slate-500">{label}</span>
        {Icon && <Icon className={`w-4 h-4 ${accent}`} strokeWidth={1.75} />}
      </div>
      <div className="text-2xl font-semibold text-slate-900">{value}</div>
      {sub && <div className="text-[10px] text-slate-400 mt-0.5">{sub}</div>}
    </Card>
  );
}

/** Horizontal proportion bar row, optionally clickable. */
export function BarRow({ label, count, total, color = "#6366F1", onClick, testid, chip, wide = false }) {
  const width = total ? Math.max((count / total) * 100, count > 0 ? 2 : 0) : 0;
  return (
    <div
      className={`flex items-center gap-2 text-xs rounded px-1 py-0.5 ${onClick ? "cursor-pointer hover:bg-slate-50" : ""}`}
      onClick={onClick}
      data-testid={testid}
    >
      {chip || (wide
        ? <div className="w-1/3 shrink-0 min-w-0 text-[11px] leading-tight text-slate-700 break-words" title={label}>{label}</div>
        : <div className="w-24 truncate font-mono text-[10px] text-slate-600" title={label}>{label}</div>)}
      <div className="flex-1 h-2 bg-slate-100 rounded overflow-hidden">
        <div className="h-full rounded" style={{ width: `${width}%`, backgroundColor: color }} />
      </div>
      <span className="w-12 text-right font-mono text-slate-700">{count}</span>
    </div>
  );
}
